export const createBoardPolling = ({
  refresh,
  isPaused,
  intervalMs = 60000,
  documentRef = document,
}) => {
  let timer;
  const poll = () => {
    if (documentRef.hidden || isPaused()) return;
    refresh();
  };
  const onVisibilityChange = () => {
    if (!documentRef.hidden) poll();
  };

  return {
    start() {
      timer = setInterval(poll, intervalMs);
      documentRef.addEventListener('visibilitychange', onVisibilityChange);
    },
    stop() {
      clearInterval(timer);
      documentRef.removeEventListener('visibilitychange', onVisibilityChange);
    },
  };
};
